import React from "react";

type Props = {
    tel: string;
    tel_error?: string;
    setValue: (name: string, value: string | boolean) => void;
};

export const InputTel = ({ tel, tel_error, setValue }: Props) => {
    return (
        <div className="form-flex">
            <div className="form-flex-txt">電話番号<span>（ハイフン無し）</span></div>
            <div className="form-flex-input">
                <input
                    type="text"
                    name="tel"
                    inputMode="numeric"
                    autoComplete="tel"
                    placeholder="0312345678"
                    pattern="\d*"
                    maxLength={11}
                    className={tel_error ? 'form-input-error' : ''}
                    value={tel}
                    onInput={(e) => {
                        const target = e.target as HTMLInputElement;
                        target.value = target.value.replace(/[^0-9]/g, "");
                    }}
                    onChange={(e) => setValue('tel', e.target.value)}
                    required
                />
                {tel_error && <span className="form-error-message">{tel_error}</span>}
            </div>
        </div>
    );
};
